/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import TransactionContainer from './dashboard/TransactionsContainer';
import SMSNotificationsContainer from './transaction/container/SMSNotificationsContainer';

function BillsContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <>
      <div className="module-inner">
        <div className="generic-module-nav mb-3">
          {Acl(permissions, ['VIEW EMAIL SMS NOTIFICATION DASHBOARD']) && (
            <NavLink
              exact
              className="nav-link"
              activeClassName="active"
              to="/notifications"
            >
              Dashboard
            </NavLink>
          )}
          {Acl(permissions, ['VIEW EMAIL SMS NOTIFICATION TRANSACTIONS']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/notifications/transaction"
            >
              SMS Notifications
            </NavLink>
          )}
        </div>
        <Switch>
          {Acl(permissions, ['VIEW EMAIL SMS NOTIFICATION DASHBOARD']) && (
            <Route
              exact
              path={`${match.path}`}
              component={TransactionContainer}
            />
          )}
          {Acl(permissions, ['VIEW EMAIL SMS NOTIFICATION TRANSACTIONS']) && (
            <Route
              path={`${match.path}/transaction`}
              component={SMSNotificationsContainer}
            />
          )}
        </Switch>
      </div>
    </>
  );
}

BillsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(BillsContainer);
